<template>
  <v-row dense>
    <v-col
      v-for="config in configs" :key="config.propName"
      :cols="getCols(config.cols)"
      :sm="getSm(config.sm)"
      :md="getMd(config.md)"
      :offset-sm="getOffsetSm(config.offsetSm)"
      :offset-md="getOffsetMd(config.offsetMd)"
      :class="getOffsetClass(config)"
    >
      <div v-if="config.sectionTitle" class="sectionTitle">
        {{config.sectionTitle}}
      </div>
      <div v-else>
        <!-- <v-text-field
          v-model="editedItem[config.propName]"
          :label="config.label"
        ></v-text-field> -->
        <div v-if="config.toplabel" class="text-h5 mb-2 ml-2">{{config.toplabel}}<span v-if="isRequired(config.type)" style="color:red">*</span></div>
        <div v-if="isCheckboxes(config)">
          <universal-input
            v-for="checkboxItemConfig in config.type.checkboxItems" :key="checkboxItemConfig.name"
            v-model="editedItem[config.propName+'_'+checkboxItemConfig.itemName]"
            :config="getCheckBoxItemConfig(config,checkboxItemConfig)"
          />
        </div>
        <universal-input
          v-else
          v-model="editedItem[config.propName]"
          :config="config"
        />
      </div>
      <div v-if="debug">
        <div>For Debug</div>
        <pre>{{JSON.stringify(config,null,4)}}</pre>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import UniversalInput from './UniversalInput'
export default {
  name: 'InputContainer',
  data () {
    return {
      editedItem: {},
      debug: false
    }
  },
  mounted () {
    Object.keys(this.editedItem).forEach(key => {
      if (this.editedItem[key] === undefined) {
        delete this.editedItem[key]
      }
    })
  },
  components: {
    UniversalInput
  },
  methods: {
    getCheckBoxItemConfig (config, checkboxItemConfig) {
      const itemConfig = {}
      itemConfig.propName = config.propName + '_' + checkboxItemConfig.itemName
      itemConfig.label = checkboxItemConfig.label
      itemConfig.type = { name: 'checkbox' }
      return itemConfig
    },
    isCheckboxes (config) {
      if (config.type && config.type.name === 'checkbox') {
        return true
      }
      return false
    },
    isRequired (type) {
      if (type && type.required) {
        return true
      }
      return false
    },
    getCols (cols) {
      return cols || 12
    },
    getSm (sm) {
      return sm || 12
    },
    getMd (md) {
      return md || 12
    },
    getOffsetSm (offsetSm) {
      return offsetSm || 0
    },
    getOffsetMd (offsetMd) {
      return offsetMd || 0
    },
    getOffsetClass (config) {
      let offsetRightClass = ''
      const mapping = [
        'xs', 'sm', 'md', 'lg', 'xl'
      ]
      let index = mapping.indexOf(this.$vuetify.breakpoint.name)
      while (index >= 0) {
        const capLetter = mapping[index].charAt(0).toUpperCase() + mapping[index].slice(1)
        const configName = `offsetRight${capLetter}`
        if (config[configName]) {
          offsetRightClass += ` offset-right-${mapping[index]}-${config[configName]}`
        }
        index--
      }
      // console.log('offsetRightClass', offsetRightClass)
      return offsetRightClass
    }
  },
  props: {
    configs: {
      type: Array,
      default () {
        return [
          {
            propName: 'name',
            label: 'Dessert name'
          },
          {
            propName: 'calories',
            label: 'Calories'
          },
          {
            propName: 'fat',
            label: 'Fat (g)'
          },
          {
            propName: 'carbs',
            label: 'Carbs (g)'
          },
          {
            propName: 'protein',
            label: 'Protein (g)'
          }
        ]
      }
    }
  }
}
</script>
<style>
  .sectionTitle{
    font-size: 2rem;

    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    color: rgba(60,59,59,1);
  }
</style>
